import { Dayjs } from 'dayjs'

export const getHumanizedDatePeriod = (
  dateFrom: Dayjs,
  dateTo: Dayjs,
  locale: string
) => {
  const isRu = locale === 'ru'

  if (dateFrom.year() === dateTo.year()) {
    if (dateFrom.month() === dateTo.month()) {
      if (isRu) {
        return `
          ${
            dateFrom.date() === dateTo.date()
              ? dateFrom.format('D MMMM')
              : dateFrom.format('D-')
          }${dateFrom.date() === dateTo.date() ? '' : dateTo.format('D MMMM')}, 
          ${dateFrom.format('YYYY')}
        `
      } else {
        return `
          ${dateFrom.format('MMMM D')}${
          dateFrom.date() === dateTo.date() ? '' : dateTo.format('-D')
        }, 
          ${dateFrom.format('YYYY')}
        `
      }
    } else if (isRu) {
      return `
            ${dateFrom.format('D MMMM')}
            ${dateTo.format(' - D MMMM')}, 
            ${dateFrom.format('YYYY')}
          `
    } else {
      return `
            ${dateFrom.format('MMMM D')}
            ${dateTo.format(' - MMMM D')}, 
            ${dateFrom.format('YYYY')}
          `
    }
  } else if (isRu) {
    return `
          ${dateFrom.format('D MMMM, YYYY')}
          ${dateTo.format(' - D MMMM, YYYY')}
        `
  } else {
    return `
          ${dateFrom.format('MMMM D, YYYY')}
          ${dateTo.format(' - MMMM D, YYYY')}
        `
  }
}

export const getHumanizedDate = (date: Dayjs, locale: string) => {
  const isRu = locale === 'ru'

  return isRu ? date.format('D MMMM, YYYY') : date.format('MMMM D, YYYY')
}
